import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { useTooltipViewType, ETooltipViewType, useOpenCloseControlled } from '../../internal';
import { TooltipMobile } from '../TooltipMobile';
import { TooltipDesktop } from '../TooltipDesktop';

/**
 * Компонент подсказки
 *
 * На телефоне работает как модальное окно
 * На планшете и десктопе работает как всплывающее окно при наведении
 *
 * Так же есть компоненты TooltipDesktop и TooltipMobile,
 * для того чтобы использовать одну конкретную версию,
 * если микросервис не подразумевает адаптива
 *
 * @export
 * @param {ITooltipProps} props
 * @returns
 */
export function Tooltip(props) {
  var _useOpenCloseControll = useOpenCloseControlled(props),
      handleOpen = _useOpenCloseControll.handleOpen,
      handleClose = _useOpenCloseControll.handleClose,
      open = _useOpenCloseControll.open;

  var viewType = useTooltipViewType({
    open: open,
    onClose: handleClose
  });

  if (viewType === ETooltipViewType.Modal) {
    return /*#__PURE__*/React.createElement(TooltipMobile, _extends({}, props, {
      open: open,
      onOpen: handleOpen,
      onClose: handleClose
    }));
  }

  return /*#__PURE__*/React.createElement(TooltipDesktop, _extends({}, props, {
    open: open,
    onOpen: handleOpen,
    onClose: handleClose
  }));
}
Tooltip.defaultProps = {
  placement: 'top'
};